import { render, staticRenderFns } from "./superUser.vue?vue&type=template&id=01b98734&"
import script from "./superUser.vue?vue&type=script&lang=js&"
export * from "./superUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports